import { FunctionField } from "react-admin";
import {
  formatNumberToPercentage,
  formatNumberToPrice,
} from "../utils/NumberUtils";

const DiscountValueField = ({ source, label, ...rest }) => {
  return (
    <FunctionField
      source={source}
      label={label}
      render={(record) => {
        if (!record.discount) return "-";
        if (record.discount.type === "PERCENTAGE") {
          return formatNumberToPercentage(record.discount.percentageValue);
        } else if (record.discount.type === "AMOUNT") {
          return formatNumberToPrice(record.discount.amountValue);
        }
        return "-";
      }}
      {...rest}
    />
  );
};

export default DiscountValueField;
